module.exports = __webpack_public_path__ + "static/media/brownstarling.be5c6fa8.png";